import type { BoxProps } from '@mui/material/Box';
import type { CardProps } from '@mui/material/Card';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CardHeader from '@mui/material/CardHeader';
import ListItemText from '@mui/material/ListItemText';

import { Iconify } from '../components/iconify';
import { Scrollbar } from '../components/scrollbar';
import { Typography } from '@mui/material';
import { IStoreState, useAppDispatch, useAppSelector } from '../../../redux';
import React from 'react';
import { fetchAllUsersProfileAsync } from '../../../redux/settings/user-profile/user-profile.actions';
import { clearAllUsersStateSync, IUserProfile } from '../../../redux/settings/user-profile';
import { ALL_USERS_LIST_ROUTE } from '../../Settings/UserProfile/UserProfile.constant';
import { useNavigate } from 'react-router-dom';
import { IPunchInOut } from '../../../redux/shifts';
import { fetchDashboardShiftsAsync } from '../../../redux/analytics/analytics.actions';
import { useOutletContext } from '../../../providers';
import { StandardCard } from '../../../Components/Card';
import { useTheme } from "@mui/material/styles";
// ----------------------------------------------------------------------

type Props = CardProps & {
  title?: string;
  subheader?: string;
  list: {
    id: string;
    name: string;
    email: string;
    avatarUrl: string;
  }[];
};



export function BankingContacts({ title, subheader,  ...other }: Props) {
  const { outlet_details: { outlet_uuid } } = useOutletContext()
  const {
    data: allUsersData,
    loading,
    totalRecords
  } = useAppSelector((storeState: IStoreState) => storeState.analytics.active_shifts_list);
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (outlet_uuid)
      dispatch(
        fetchDashboardShiftsAsync(outlet_uuid),
      );

  }, [outlet_uuid]);



  const handleOnViewAllUsersClick = () => {
    navigate(ALL_USERS_LIST_ROUTE)
  }
  return (
    <StandardCard heading={title} subheading={`You have ${totalRecords} Users`} headingAlignment='flex-end' rightHeading={
      <Button
        size="small"
        color="inherit"
        sx={{
          backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
          color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
          border: isLightMode ? "1px solid var(--border-light-color)" : "1px solid var(--border-dark-color)",
          "&:hover": {
            backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--tertiary-color)",
            opacity: isLightMode ? 0.85 : 1,
          }
        }}
        onClick={handleOnViewAllUsersClick}
        endIcon={<Iconify icon="eva:arrow-ios-forward-fill" width={18} sx={{ ml: -0.5 }} />}
      >
        View all
      </Button>
    } >
     

      
        <Box
          sx={{
            p: 3,
            gap: 3,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 200,
          }}
        >
          {allUsersData.map((item) => (
            <Item key={item.user_uuid} item={item} />
          ))}
        </Box>
      
    </StandardCard>
  );
}

// ----------------------------------------------------------------------

type ItemProps = BoxProps & {
  item: IPunchInOut;
};

// Function to determine job role based on user data





function Item({ item, sx, ...other }: ItemProps) {

  
  return (
    <Box 
      key={item.user_uuid} 
      sx={{ 
        display: 'flex',
        alignItems: 'center',
        p: 1.5,
        borderRadius: 1,
        bgcolor: 'background.paper',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        '&:hover': {
          bgcolor: 'background.neutral',
          transition: 'background-color 0.3s'
        },
        ...sx 
      }} 
      {...other}
    >
      <Avatar 
        src={item.user_image || ""} 
        sx={{ 
          width: 48, 
          height: 48,
          border: '2px solid #f8f8f8',
        }}
      />
      
      <Box sx={{ ml: 2, flexGrow: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.3 }}>
          {item.user_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {item.punch_date || item.work_time || item.duration || "Active"}
        </Typography>
      </Box>
    </Box>
  );
}
